import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchAboutData = createAsyncThunk("about/fetchData", async () => {
    try {
        const response = await api.get("/about");
        const data = response.data.data;
        return data;
    } catch (error) {
        return error;
    }
});

export const aboutSlice = createSlice({
    name: "about",
    initialState: {
        loading: false,
        error: null,
        about: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAboutData.pending, (state) => {
            state.loading = true;
            state.error = null;
        }).addCase(fetchAboutData.fulfilled, (state, action) => {
            state.loading = false;
            state.about = action.payload;
        }).addCase(fetchAboutData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
    }
});

export default aboutSlice.reducer;




